/**
 * @module pxToRem
 * PX -> REM mapping
 *
 * Copied from Tailwind spacing @see {@link https://tailwindcss.com/docs/customizing-spacing#default-spacing-scale}
 * For advantages of rem for spacing values @see {@link https://engageinteractive.co.uk/blog/em-vs-rem-vs-px}
 **/
export const pxToRem = {
  2: "0.125rem",
  4: "0.25rem",
  6: "0.375rem",
  8: "0.5rem",
  10: "0.625rem",
  12: "0.75rem",
  14: "0.875rem",
  16: "1rem",
  18: "1.125rem",
  20: "1.25rem",
  24: "1.5rem",
  28: "1.75rem",
  32: "2rem",
  36: "2.25rem",
  40: "2.5rem",
  48: "3rem",
  56: "3.5rem",
  64: "4rem",
  80: "5rem",
  96: "6rem",
  112: "7rem",
  128: "8rem",
  144: "9rem",
  160: "10rem",
  176: "11rem",
  192: "12rem",
  224: "14rem",
  240: "15rem",
  256: "16rem",
  288: "18rem",
  300: "18.75em",
  320: "20rem",
  384: "24rem",
  464: "29rem",
} as const;

export type PxToRem = typeof pxToRem;

export type SpacingPxs = keyof PxToRem;

export type SpacingRems = PxToRem[keyof PxToRem];
